<template>
	<div class="p-grid">

		<div class="p-col-12">
			<div class="card">
			<Panel header="LOGROS ACADÉMICOS Y/O PROFESIONALES MÁS IMPORTANTES:" style="height: 100%">

				<Toolbar class="p-mb-4">
					<template v-slot:left>
						<Button label="Registrar" icon="pi pi-plus" class="p-button-success p-mr-2" @click="openNew" />
					</template>
					<template v-slot:right>
						<span class="p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText  v-model="filters['global'].value" placeholder="Buscar..." />
                        </span>
					</template>
				</Toolbar>
				
				<DataTable :value="logrosacad" v-model:selection="logroItem" class="p-datatable-gridlines" dataKey="idLogro" :filters="filters" rows="5" style="margin-bottom: 20px" :paginator="true"
				responsiveLayout="scroll">		
			
				<Column field="descripLogro" header="Descripción del Logro" :sortable="true"></Column>							
				<Column style="width:120px">
					<template #header>
						Acciones
					</template>
					<template #body="slotProps">
                        <Button icon="pi pi-pencil" type="button" class="p-button-success p-mr-2 p-mb-1" @click="showeditLogro(slotProps.data)"></Button>
                        <Button icon="pi pi-trash" type="button" class="p-button-danger p-mb-1" @click="confirmDeleteLogro(slotProps.data)"></Button>
					</template>
				</Column>
			</DataTable>
				
				</Panel>
				<br>
			<Toast/>

			<Dialog v-model:visible="logroDialog" :style="{width: '470px'}" header="Registrar Logro Académico o Profesional" :modal="true" class="p-fluid">
					<div class="p-field">
						<label for="name">Descripción del Logro Académico o Profesional:</label>
						<Textarea id="descripcion" v-model="logroItem.descripcion" required="true" rows="3" cols="20" :class="{'p-invalid': submitted && validarErrores.descripcion}"/>
						<small class="p-error" v-show="submitted && validarErrores.descripcion">La descripción del Logro es requerida.</small>
					</div>								
					
					<template #footer>
						<Button label="Cancelar" icon="pi pi-times" class="p-button-danger" @click="hideDialog"/>
						<Button label="Guardar " icon="pi pi-check" class="p-button-primary" @click="saveLogro" />
					</template>
			</Dialog>

			<Dialog v-model:visible="editarDialog" :style="{width: '470px'}" header="Editar Logro Académico o Profesional" :modal="true" class="p-fluid">
					
					<div class="p-field">
						<label for="name">Descripción del Logro Académico o Profesional:</label>
						<Textarea id="descripcion" v-model="logroItem.descripcion" required="true" rows="3" cols="20" :class="{'p-invalid': submitted && validarErrores.descripcion}"/>
						<small class="p-error" v-show="submitted && validarErrores.descripcion">La descripción del Logro es requerida.</small>
					</div>								
					
					<template #footer>
						<Button label="Cancelar" icon="pi pi-times" class="p-button-danger" @click="hideDialogEditar"/>
						<Button label="Editar " icon="pi pi-check" class="p-button-primary" @click="editLogro" />
					</template>
			</Dialog>


			<Dialog v-model:visible="deleteLogroDialog" :style="{width: '450px'}" header="Confirmación" :modal="true">
					<div class="confirmation-content">
						<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
						<span>¿ Deseas eliminar el registro seleccionado ?</span>
					</div>
					<template #footer>
						<Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteLogroDialog = false"/>
						<Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deleteLogrosAcad" />
					</template>
			</Dialog>
			</div>			
		</div>
	</div>
</template>
<script>
import apiLogros from '@/service/LogrosService';
import { FilterMatchMode } from 'primevue/api';


export default {
		data() {
				return{
					logrosacad: [],
					logroItem: {
						idLogro: null,					
						descripcion:null,
						noPlaza: null
					},
					logroDialog: false,
					editarDialog: false,
					deleteLogroDialog: false,
					filters: [{
							'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
					}],		
					Logro: {},					
					validarErrores: {},	
					submitted: false,
				}
		},		
		created() {
			this.initialize() 
			this.initFilters();
		},
		mounted() {
			this.readLogrosAcad();
		},
		methods: {
			initialize () {
			this.readLogrosAcad();
			}, 
			readLogrosAcad: async function() {   //Leer datos desde el API REST
				const data = await apiLogros.readLogrosAcad(window.localStorage.getItem('noPlaza'));
				this.logrosacad = data;
			},	
			insertLogrosAcad: async function() { 
				const requestData = {
					idLogro: "", 
					noPlaza: window.localStorage.getItem('noPlaza'),      				
					descripcion: this.logroItem.descripcion,
				};
				
				await apiLogros.createLogrosAcad(requestData); //Insertar el item mediante API REST     				
				this.logroItem.descripcion = "";
				this.readLogrosAcad();
				this.$toast.add({severity:'success', summary: 'Confirmación', detail: 'Logro registrado', life: 3000});
			},	
			updateLogrosAcad: async function() { 
				const requestData = {
					idLogro: this.logroItem.idLogro, 
					noPlaza: window.localStorage.getItem('noPlaza'),       				
					descripcion: this.logroItem.descripcion,
				};
				
				await apiLogros.updateLogrosAcad(this.logroItem.idLogro,requestData); 				
				this.logroItem.descripcion = "";
				this.readLogrosAcad();
				this.$toast.add({severity:'success', summary: 'Confirmación', detail: 'Logro modificado', life: 3000});
			},
			deleteLogrosAcad: async function() {
				await apiLogros.deleteLogrosAcad(this.logroItem.idLogro);								
				this.readLogrosAcad();
				this.deleteLogroDialog = false;						
				this.$toast.add({severity:'success', summary: 'Acción correcta', detail: 'Logro eliminado', life: 3000});
			},
			openNew() {	
				this.submitted = false;
				this.logroItem={	
					noPlaza:'',			
					descripcion:''
				}
				this.logroDialog = true;
			},
			hideDialog() {
				this.logroDialog = false;
				this.submitted = false;
			},
			hideDialogEditar() {
				this.editarDialog = false;
				this.submitted = false;
			},
			saveLogro() {
				this.submitted = true;
				if (this.validarForm() ) {				
					this.insertLogrosAcad();
					this.hideDialog();
				}
			},
			editLogro() {
				this.submitted = true;
				if (this.validarForm() ) {				
					this.updateLogrosAcad();
					this.hideDialogEditar();
				}
			},
			validarForm() {
				
				if (!this.logroItem.descripcion.trim())
					this.validarErrores['descripcion'] = true;
				else
					delete this.validarErrores['descripcion'];

				return !Object.keys(this.validarErrores).length;
			},		
			confirmDeleteLogro(log) {				
				this.logroItem.idLogro = log.idLogro;				
				this.deleteLogroDialog = true;				
			},
			showeditLogro(logrodata) {
				this.logroItem={
					idLogro: logrodata.idLogro,				
					descripcion: logrodata.descripLogro
				} 
				this.editarDialog = true;				
			},
			initFilters() {
            this.filters = {
				'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
				}
			},
		}
	}
</script>

<style scoped lang="scss">
	.table-header {
		display: flex;
		justify-content: space-between;
	}
</style>